module.exports = __webpack_public_path__ + "static/img/signal-catch.a9a4b193.svg";